export default __webpack_public_path__ + "static/media/warning-empty.0a56ff8e.svg";